"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignOfferDocFE = exports.OfferContentWithId = exports.CampaignOfferDoc = exports.CampaignOffer = exports.MMPTaskConfigWithPostbackSchema = void 0;
const zod_1 = require("zod");
const types_1 = require("../../types");
exports.MMPTaskConfigWithPostbackSchema = types_1.MMPTaskConfig.pick({
    taskId: true,
    taskDescription: true,
    rewards: true,
    previousTaskRequirements: true,
}).merge(zod_1.z.object({
    mmpPostbackTaskName: zod_1.z.string(),
}));
exports.CampaignOffer = zod_1.z.object({
    activatedDurationDays: zod_1.z.number(),
    offerDetails: zod_1.z.string().nullable(),
    coinsPerDollar: zod_1.z.number(),
    createdTimestamp: types_1.FTimestamp.optional(),
    dailyInstallCap: zod_1.z.number().nullable(),
    dayXRewards: zod_1.z
        .array(zod_1.z.object({
        day: zod_1.z.number(),
        rewards: types_1.ResourceRewards,
    }))
        .optional(),
    eligibleSpendAmount: zod_1.z.number(),
    endTimestamp: types_1.FTimestamp.nullable(),
    hourlyInstallCap: zod_1.z.number().nullable(),
    installRewards: zod_1.z
        .object({
        coins: zod_1.z.number().optional(),
        piggyBanks: zod_1.z.number().optional(),
    })
        .optional(),
    isActive: zod_1.z.boolean(),
    isUAOffer: zod_1.z.boolean(),
    manualSort: zod_1.z.number(),
    mmpAttributionRequiredForEligibility: zod_1.z.boolean(),
    mmpAttributionRequiredForRewards: zod_1.z.boolean(),
    mmpAttributionSupported: zod_1.z.boolean(),
    offerType: types_1.OfferTypeEnum,
    ordering: zod_1.z.number(),
    piggyPerDollar: zod_1.z.number(),
    startTimestamp: types_1.FTimestamp,
    updatedAt: types_1.FTimestamp.optional(),
    userTargeting: types_1.UserTargeting.optional(),
    valueStatement: zod_1.z.string().optional(),
    excludeFromDynamicScaling: zod_1.z.boolean().optional(), // Optional now, should become required after release
    // TODO - restrict these based on offerType = GENERIC_OFFER
    batchPlaytimeConfig: types_1.BatchPlaytimeConfig.nullable().optional(),
    tasks: zod_1.z.array(types_1.GenericTaskConfig).optional(),
    tiebreakerWeighting: zod_1.z.number().optional(),
    // MMP
    mmpEventTasks: zod_1.z.array(exports.MMPTaskConfigWithPostbackSchema).optional(),
    playtimeRewardsConfig: zod_1.z.string().optional(),
    playtimeRewards: zod_1.z
        .array(zod_1.z.object({
        minutes: zod_1.z.number(),
        rewards: zod_1.z.object({
            coins: zod_1.z.number(),
            piggyBanks: zod_1.z.number(),
        }),
    }))
        .optional(),
    totalPlaytimeCoinRewards: zod_1.z.number().optional(),
    totalPlaytimePiggyBankRewards: zod_1.z.number().optional(),
    partnerAppSettings: zod_1.z.record(zod_1.z.string(), types_1.PartnerAppOfferSettings).optional(),
});
exports.CampaignOfferDoc = exports.CampaignOffer.merge(types_1.DocId).omit({
    valueStatement: true,
});
exports.OfferContentWithId = zod_1.z.object({
    campaign: types_1.PublisherCampaign,
    offer: exports.CampaignOfferDoc,
});
exports.CampaignOfferDocFE = exports.CampaignOfferDoc.pick({
    id: true,
    activatedDurationDays: true,
    coinsPerDollar: true,
    dayXRewards: true,
    eligibleSpendAmount: true,
    installRewards: true,
    offerType: true,
    piggyPerDollar: true,
    isUAOffer: true,
    batchPlaytimeConfig: true,
    tasks: true,
    mmpAttributionRequiredForRewards: true,
    offerDetails: true,
}).extend({
    valueStatement: zod_1.z.string().optional(),
});
